module.exports = __webpack_public_path__ + "static/fipcbrownleopard2-370c11dbef17c709cdb2ea4ed496a99d.jpeg";